import React, { useEffect, useState } from 'react';

import useGetClientHistory from '../../../api/super-admin/clients/useGetClientHistory';
import GenericModal from '../../../components/agv-generic-modal';
import { MODAL_SIZE, MODAL_SIZE_STYLE } from '../../../enums/modal-size.enum';
import {
  computeJsonDiff,
  formatDateTime,
  HISTORY_EVENT_LABELS,
} from '../client-diff';
import ClientChangesDiff from './client-changes-diff';

const HistoryEvent = ({ event }) => {
  const [isOpen, setIsOpen] = useState(
    event.event_type === 'CLIENT_UPDATED' || event.event_type === 'LOGO_UPDATED'
  );
  const diff = computeJsonDiff(event.datas_before, event.datas_after);
  const author = event.user_full_name || event.user_email;

  return (
    <li className="tw-relative tw-border-0 tw-border-l tw-border-solid tw-border-black/10 tw-pb-4 tw-pl-6 last:tw-border-transparent">
      <span
        className="tw-absolute tw-left-[-5px] tw-top-1 tw-size-2.5 tw-rounded-full tw-bg-main"
        aria-hidden="true"
      />
      <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-2">
        <span className="tw-text-sm tw-font-medium">
          {HISTORY_EVENT_LABELS[event.event_type] || event.event_type}
        </span>
        {diff.length > 0 && (
          <button
            type="button"
            onClick={() => setIsOpen((previous) => !previous)}
            className="tw-border-0 tw-bg-transparent tw-p-0 tw-text-xs tw-text-main hover:tw-underline"
          >
            {isOpen
              ? 'Masquer le détail'
              : `Voir le détail (${diff.length} champ${diff.length > 1 ? 's' : ''})`}
          </button>
        )}
      </div>
      <div className="tw-mt-0.5 tw-text-xs tw-text-text-dark-medium-importance">
        {formatDateTime(event.created_at)}
        {author ? ` · par ${author}` : ' · script de migration'}
      </div>
      {isOpen && diff.length > 0 && (
        <div className="tw-mt-2">
          <ClientChangesDiff diff={diff} />
        </div>
      )}
    </li>
  );
};

/**
 * Historique du paramétrage du client : qui a modifié quoi, quand, avec
 * l'avant / après de chaque modification.
 */
export default function ClientHistoryModal({ isOpen, setIsOpen, clientId }) {
  const [history, setHistory] = useState(null);
  const { isLoading, fetchHistory } = useGetClientHistory();

  useEffect(() => {
    if (!isOpen || !clientId) return;

    const loadHistory = async () => setHistory(await fetchHistory(clientId));
    loadHistory();
  }, [isOpen, clientId]);

  return (
    <GenericModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title="Historique du paramétrage"
      size={MODAL_SIZE_STYLE[MODAL_SIZE.XL]}
      secondaryActionText="Fermer"
      secondaryAction={() => setIsOpen(false)}
    >
      {isLoading || history == null ? (
        <p className="tw-m-0 tw-text-sm tw-text-text-dark-medium-importance">
          Chargement de l’historique…
        </p>
      ) : history.length === 0 ? (
        <p className="tw-m-0 tw-text-sm tw-text-text-dark-medium-importance">
          Aucune modification enregistrée.
        </p>
      ) : (
        <ol className="tw-m-0 tw-list-none tw-p-0 tw-pl-1">
          {history.map((event) => (
            <HistoryEvent key={event.id} event={event} />
          ))}
        </ol>
      )}
    </GenericModal>
  );
}
